import React, {useEffect} from "react";
import Container from 'react-bootstrap/Container';
import '../Lg.css';
import {lgSetup} from "../../../backend/LgSetup";
import {TildaB} from "./common/TildaB";
import {logInfo, logPageOpened} from "../../model/utils";
import {
    calculateConcertFullInfoUrl,
    calculateFullInfoUrl,
    calculateLeadGenerationUrl,
    calculateShortPageToLmUrl,
    calcWhere
} from "./common/LgHelper";
import {appdata} from "../../../logic_tmp/appdata/AppData";


function randomChange(data, url) {
    let random = Math.random()
    if (random > 0.5)
    {
        data["abTest1"] = "NextPageA"
        logInfo("A-Selected")
        return url + "&abTest1=" + data["abTest1"]
    }
    data["abTest1"] = "NextPageB-Geo"
    logInfo("B-Selected")
    return url.replace("202305-next","202305-next-b")  + "&abTest1=" + data["abTest1"]
}


export function ConcertShortFooter() {
    appdata.viewType = "ShortPage"
    useEffect(() => {
        logPageOpened(appdata.parentPath,appdata.viewType)
    }, []);
    return (
        <div>
            <Container>
                <TildaB>
                    <div>
                        <a id ="toConcertFull" href={randomChange(appdata,calculateConcertFullInfoUrl(appdata))} target="_parent"
                           className="myButton myButton">Продолжить</a>
                    </div>
                </TildaB>
            </Container>
        </div>
    );
}

